import { addParamsToUrl, EmailDetailsService, sanitizeHtml, parse, DownloadFileFromEmail} from '@/imports-files/pages/clients/communication/email-details';



export class EmailDetailsAction
{
    constructor(setApiError, setShowCandidateEmail, router)
    {
      this.setApiError =  setApiError
      this.setShowCandidateEmail = setShowCandidateEmail;
      this.emailDetailsService = new EmailDetailsService();
      this.router = router;
    }

    async getEmailData()
    {
        let params = {};
        let comms_id = this.router.query.comm_detail_id;
        let result = await this.emailDetailsService.getEmailDetailData(params, comms_id);
        this.setApiError(result.request);
        return result.data
    }


    openJobOptions(event)
        {
            event.stopPropagation();
            var dots_element = event.currentTarget.querySelector('.Dots');
            var element = event.currentTarget.querySelector('.EmailsDetailsOptions')

            if(dots_element.classList.contains('Close'))
            {
                this.closeAllJobsOptions();
                element.classList.remove('Close');
                element.classList.add('Open');

                dots_element.classList.remove('Close');
                dots_element.classList.add('Open');
            }
            else
            {
                this.closeAllJobsOptions();
                element.classList.remove('Open');
                element.classList.add('Close');

                dots_element.classList.remove('Open');
                dots_element.classList.add('Close');
            }
    }

    closeAllJobsOptions()
    {
        var element = document.querySelector('.EmailsDetailsOptions.Open');
        var dots_element = document.querySelector('.Dots.Open');
        if(element)
        {
            element.classList.remove('Open');
            element.classList.add('Close');
            dots_element.classList.remove('Open');
            dots_element.classList.add('Close');
        }
    }

    html_txt_parsing(message_body) {
      try {
        message_body = sanitizeHtml(message_body, {allowedTags: false, allowedAttributes: false})
        return parse(`${message_body}`);
      }
      catch (err) {
        return message_body
      }
    }

    html_txt_parsing_text_only(message_body) {
      try {
        message_body = sanitizeHtml(message_body, {allowedTags: [], allowedAttributes: {}})
        return parse(`${message_body}`);
      }
      catch (err) {
        return message_body
      }
    }

    async toggle(event, data, page_name)
    {
        let params = {};
        let result = '';
        event.stopPropagation();
        
        params['id'] = [this.router.query.comm_detail_id]
        params['comm_detail_id'] = [data.id] ;
        
        let element_classes = event.currentTarget;
        if(element_classes.classList.contains('ImportantEmail'))
        {
            params['important'] = false;
            result = await this.emailDetailsService.markAsImportantAndUnimportant(params)
            if(result.status == 200)
            {
              element_classes.classList.remove('ImportantEmail');
              element_classes.classList.add('NotImportantEmail')
            }
        }
        else
        {
            params['important'] = true;
            result = await this.emailDetailsService.markAsImportantAndUnimportant(params)
            if(result.status == 200)
            {
              element_classes.classList.remove('NotImportantEmail');
              element_classes.classList.add('ImportantEmail')
            }
        }

       
    }

    getToData(data)
    {
        let return_data = '';
        for(let element of data)
        {
            if(return_data == '')
            {
                return_data  = (element.name || element.email)
            }
            else
            {
              return_data = return_data+', '+(element.name || element.email)
            } 
        }
        return return_data;
    }

    onChangeAccordion(uuid)
    {

        let all_element = document.querySelectorAll('.EmailTo');
        for(let element of all_element)
        {
          element.style.display = 'none'
        }

        let all_show_element_text = document.querySelectorAll('.Texts');
        for(let element of all_show_element_text)
        {
          element.style.display = 'block'
        }

      if(uuid.length != 0 )
      {
        let current_element = document.querySelectorAll(`.${uuid} .EmailTo`)
        for(let element of current_element)
        {
          element.style.display = 'block'
        }

        let show_element_text = document.querySelectorAll(`.${uuid} .Texts`) 
         for(let element of show_element_text)
        {
          element.style.display = 'none'
        }
      }
      
    }

    preExpand()
    {
      let element = document.querySelector('.AccordionItem.Item_1 .Texts');
      if(element) element.style.display = 'none'
    }

    async actionDownloadFileFromEmail(event, attachment) {
    const downloadLink  = document.createElement("a");
    downloadLink.setAttribute("target", "_blank");
    downloadLink.setAttribute('download','');
    downloadLink.href   =  attachment.attachment_url;
    downloadLink.download = attachment.fileName;
    downloadLink.click();
}
}